import React, { useRef } from 'react';

import TopUpModal, {
  TopUpModalRef,
} from '@/components/Modals/TopUpModal/TopUpModal';
import { formatCurrency } from '@/Utils/helpers';
import FreePlanRequired, {
  FreePlanRequiredRef,
} from '@/components/Modals/FreePlanReqiured';

const CreditBalance = ({ balance, isOpenUpgradeModal }) => {
  const topUpModalRef = useRef<TopUpModalRef>(null);
  const modalRef = useRef<FreePlanRequiredRef>(null);
  const handleTopUpClick = () => {
    isOpenUpgradeModal
      ? modalRef.current?.openModal()
      : topUpModalRef.current?.openModal();
  };

  return (
    <>
      <div>
        <h3 className='form-title mt-8'>Available Balance</h3>
        <div className='flex justify-between p-8 w-full bg-bodyBg rounded-lg items-center box-border'>
          <div className='flex gap-8'>
            <img src='/icons/balance-icon.svg' alt=' ' />
            {balance ? (
              <p className='text-18px font-serif'>{formatCurrency(balance)}</p>
            ) : (
              <p className='text-18px font-serif'>$00,000.00</p>
            )}
          </div>
          <button className='button' onClick={handleTopUpClick}>
            Top Up
          </button>
        </div>
      </div>

      {<TopUpModal ref={topUpModalRef} />}
      {<FreePlanRequired ref={modalRef} />}
    </>
  );
};
export default CreditBalance;
